"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localizedThresholdValidatorErrorKeys = exports.LocalizedThresholdValidatorErrorKey = exports.LocalizedThresholdValidatorType = void 0;
/**
 * Localized Threshold Validator Types enum.
 */
var LocalizedThresholdValidatorType;
(function (LocalizedThresholdValidatorType) {
    LocalizedThresholdValidatorType["GREATER_EQUAL"] = "GREATER_EQUAL";
    LocalizedThresholdValidatorType["GREATER"] = "GREATER";
    LocalizedThresholdValidatorType["LESS_EQUAL"] = "LESS_EQUAL";
    LocalizedThresholdValidatorType["LESS"] = "LESS";
})(LocalizedThresholdValidatorType = exports.LocalizedThresholdValidatorType || (exports.LocalizedThresholdValidatorType = {}));
/**
 * Localized Threshold Validator Error Keys enum.
 */
var LocalizedThresholdValidatorErrorKey;
(function (LocalizedThresholdValidatorErrorKey) {
    LocalizedThresholdValidatorErrorKey["THRESHOLD"] = "LOCALIZED_THRESHOLD_VALIDATOR_THRESHOLD";
    LocalizedThresholdValidatorErrorKey["REQUIRED"] = "LOCALIZED_THRESHOLD_VALIDATOR_REQUIRED";
    LocalizedThresholdValidatorErrorKey["PARSE"] = "LOCALIZED_THRESHOLD_VALIDATOR_PARSE";
})(LocalizedThresholdValidatorErrorKey = exports.LocalizedThresholdValidatorErrorKey || (exports.LocalizedThresholdValidatorErrorKey = {}));
/**
 * An Array of the Localized Threshold Validator Error Keys.
 */
exports.localizedThresholdValidatorErrorKeys = Object.keys(LocalizedThresholdValidatorErrorKey).map((key) => LocalizedThresholdValidatorErrorKey[key]);
//# sourceMappingURL=LocalizedThresholdValidatorFn.js.map